const DeviceMobile = 'mobile';
const DeviceDesktop = 'desktop';
const operatingSystems = [
    { name: 'android', regex: /Android/ },
    { name: 'ios', regex: /(iPhone|iPad|iPod)/ },
    { name: 'windows', regex: /Windows/ },
    { name: 'openbsd', regex: /OpenBSD/ },
    { name: 'linux', regex: /(Linux|X11)/ },
    { name: 'macos', regex: /Mac OS X/ },
    { name: 'unix', regex: /UNIX/ },
];
function detectDevice(userAgent) {
    const isMobile = /Mobi/.test(userAgent);
    let matchedOs = 'unknown';
    for (const os of operatingSystems) {
        if (os.regex.test(userAgent)) {
            matchedOs = os.name;
            break;
        }
    }
    return {
        type: isMobile ? DeviceMobile : DeviceDesktop,
        os: matchedOs,
    };
}

export { DeviceDesktop, DeviceMobile, detectDevice };
//# sourceMappingURL=detectDevice.js.map
